import { FormattedMessage } from '@flipster/i18n';
import { createDropdownSelect } from '@flipster/react/design-system/dropdown/dropdown-select';

import { CopyTradeSortKey } from '../utils';

const Dropdown = createDropdownSelect<CopyTradeSortKey>();

const sortKeys = [
  'pnl',
  'roi',
  'winRate',
  'copiers',
  'copiersPnl',
  'aum',
  'maxDrawdown',
  'sharpe',
] as const satisfies CopyTradeSortKey[];

const sortLabelId = {
  pnl: 'Assets.r250401.Pnl',
  roi: 'Common.r251127.Roi',
  winRate: 'Copy.r251107.Win_rate',
  copiers: 'Copy.r251107.Copiers',
  copiersPnl: 'Copy.r251107.Copier_pnl',
  aum: 'Autogen_common.r251126.s_AUM',
  maxDrawdown: 'Copy.r251107.Max_drawdown',
  sharpe: 'Copy.r251107.Sharpe_ratio',
} as const;

interface SortDropdownProps {
  sortKey: CopyTradeSortKey;
  onChange: (sortKey: CopyTradeSortKey) => void;
}

export const SortDropdown = ({ sortKey, onChange }: SortDropdownProps) => {
  return (
    <Dropdown.Root selected={sortKey} onChange={onChange} placement='bottom-start'>
      <Dropdown.TriggerChip />
      <Dropdown.Select portal>
        {sortKeys.map((value) => (
          <Dropdown.Item key={value} value={value} label={<FormattedMessage id={sortLabelId[value]} />} />
        ))}
      </Dropdown.Select>
    </Dropdown.Root>
  );
};
